import { organisationConstants } from '../../../_constants/organisation.constants';
import { organisationService } from '../../../_services/organisation.service';

export const RoleFitmentReportAction = {
    getHolderAndOrganisationCompetencyAction,
    getOrganisationFitmentsAction,
    getOrganisationFitmentsListAction,
    createOrganisationFitmentsAction,
    updateOrganisationFitmentsAction,
    getAllotedOrganisationFitmentsAction,
    deleteOrganisationFitmentsAction
};

function deleteOrganisationFitmentsAction({orgId, fitment_id, requestObject, callback=()=>{}}) {
    return dispatch => {
        dispatch(request());
        organisationService.deleteOrganisationFitments({orgId, fitment_id, requestObject})
            .then(
                organisation_fitments => {
                    dispatch(success(organisation_fitments));
                    callback(organisation_fitments)
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: organisationConstants.REQUEST_DELETE_ORGANISATION_FITMENTS,  } }
    function success(organisation_fitments) { return { type: organisationConstants.RECEIVE_DELETE_ORGANISATION_FITMENTS, organisation_fitments } }
    function failure(error) { return { type: organisationConstants.DELETE_ORGANISATION_FITMENTS_ERROR, error } }
}

function getHolderAndOrganisationCompetencyAction(requestObject, {successCallback=()=>{}}={}) {
    return dispatch => {
        dispatch(request());
        organisationService.getHolderAndOrganisationCompetency(requestObject)
            .then(
                holder_list_and_organisation_competency => {
                    dispatch(success(holder_list_and_organisation_competency.data));
                    successCallback(holder_list_and_organisation_competency.data);
                },
                holder_list_and_organisation_competency_error_data => {
                    dispatch(failure(holder_list_and_organisation_competency_error_data));
                }
            );
    };

    function request() { return { type: organisationConstants.REQUEST_GET_HOLDER_LIST_AND_ORGANISATION_COMPETENCY,  } }
    function success(holder_list_and_organisation_competency) { return { type: organisationConstants.RECEIVE_GET_HOLDER_LIST_AND_ORGANISATION_COMPETENCY, holder_list_and_organisation_competency } }
    function failure(holder_list_and_organisation_competency_error_data) { return { type: organisationConstants.GET_HOLDER_LIST_AND_ORGANISATION_COMPETENCY_ERROR, holder_list_and_organisation_competency_error_data } }
}

function getOrganisationFitmentsAction(requestObject) {
    return dispatch => {
        dispatch(request());
        organisationService.getOrganisationFitments(requestObject)
            .then(
                organisation_fitments => {
                    dispatch(success(organisation_fitments));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: organisationConstants.REQUEST_GET_ORGANISATION_FITMENTS,  } }
    function success(organisation_fitments) { return { type: organisationConstants.RECEIVE_GET_ORGANISATION_FITMENTS, organisation_fitments } }
    function failure(error) { return { type: organisationConstants.GET_ORGANISATION_FITMENTS_ERROR, error } }
}


function getOrganisationFitmentsListAction({orgId}) {
    return dispatch => {
        dispatch(request());
        organisationService.getOrganisationFitmentsList({orgId})
            .then(
                organisation_fitments => {
                    dispatch(success(organisation_fitments.data.organisation_fitment_list));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: organisationConstants.REQUEST_GET_ORGANISATION_FITMENTS_LIST,  } }
    function success(organisation_fitments) { return { type: organisationConstants.RECEIVE_GET_ORGANISATION_FITMENTS_LIST, organisation_fitments } }
    function failure(error) { return { type: organisationConstants.GET_ORGANISATION_FITMENTS_LIST_ERROR, error } }
}
function createOrganisationFitmentsAction({orgId, requestObject, callback=()=>{}}) {
    return dispatch => {
        dispatch(request());
        organisationService.createOrganisationFitments({orgId, requestObject})
            .then(
                create_organisation_fitments => {
                    dispatch(success(create_organisation_fitments));
                    callback(create_organisation_fitments)
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: organisationConstants.REQUEST_CREATE_ORGANISATION_FITMENTS,  } }
    function success(create_organisation_fitments) { return { type: organisationConstants.RECEIVE_CREATE_ORGANISATION_FITMENTS, create_organisation_fitments } }
    function failure(error) { return { type: organisationConstants.CREATE_ORGANISATION_FITMENTS_ERROR, error } }
}

function updateOrganisationFitmentsAction({orgId, fitment_id, requestObject, callback=()=>{}}) {
    return dispatch => {
        dispatch(request());
        organisationService.updateOrganisationFitments({orgId, fitment_id, requestObject})
            .then(
                update_organisation_fitments => {
                    dispatch(success(update_organisation_fitments));
                    callback(update_organisation_fitments);
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: organisationConstants.REQUEST_UPDATE_ORGANISATION_FITMENTS,  } }
    function success(update_organisation_fitments) { return { type: organisationConstants.RECEIVE_UPDATE_ORGANISATION_FITMENTS, update_organisation_fitments } }
    function failure(error) { return { type: organisationConstants.UPDATE_ORGANISATION_FITMENTS_ERROR, error } }
}

function getAllotedOrganisationFitmentsAction(requestObject, callback=()=>{}) {
    return dispatch => {
        dispatch(request());
        organisationService.getAllotedOrganisationFitments(requestObject)
            .then(
                allotted_organisation_fitments => {
                    dispatch(success(allotted_organisation_fitments));
                    callback(allotted_organisation_fitments);
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: organisationConstants.REQUEST_GET_ALLOTED_ORGANISATION_FITMENTS,  } }
    function success(allotted_organisation_fitments) { return { type: organisationConstants.RECEIVE_GET_ALLOTED_ORGANISATION_FITMENTS, allotted_organisation_fitments } }
    function failure(error) { return { type: organisationConstants.GET_ALLOTED_ORGANISATION_FITMENTS_ERROR, error } }
}


// WEBPACK FOOTER //
// ./src/_actions/organisations/roleFitmentReport/roleFitmentReport.action.js